import { type RedirectUrlFragment } from '#graphql-operations'

export default async function (route: any): Promise<void> {
  if (route !== null && typeof route.value?.redirect === 'string') {
    const redirect: RedirectUrlFragment = route.value
    await useRedirect(redirect.redirect)
  }
}
